/**
 * @module @repo/global-login-sdk/cn
 * Winziger, abhängigkeitsfreier Klassen-Merger für das SDK (ersetzt `clsx`,
 * damit die einbettbaren Dialoge ohne zusätzliche Runtime-Dependency auskommen).
 */

/**
 * Fügt `className`-Fragmente zusammen und verwirft falsy Werte. So bleiben
 * bedingte Klassen lesbar, ohne dass Arrays direkt an `className` übergeben werden.
 *
 * Hinweis: Dies ist bewusst KEIN `tailwind-merge` — es dedupliziert/überschreibt
 * KEINE konfliktierenden Tailwind-Utilities (z. B. `p-2 p-4` bleibt beides stehen).
 * Für die SDK-internen Dialoge reicht das simple Verketten; die letzte Utility
 * gewinnt hier nach CSS-Kaskade, nicht nach String-Reihenfolge. Nur SDK-intern
 * genutzt (kein öffentlicher Ersatz für `clsx`/`tailwind-merge` der Host-App).
 *
 * @param parts Klassennamen oder falsy Platzhalter (`false`/`null`/`undefined`).
 * @returns Der zusammengesetzte, leerzeichen-getrennte `className`-String.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
